import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { numberFormat } from '@fiverr-private/localization';
import { useAttachments } from '../../context/contexts/attachments';
import { Attachment } from '../Attachment';
import classes from './style.module.scss';

export const AttachmentsNotConnected = ({ attachments = [], className }) => {
    const length = attachments.length;

    if (length === 0) {
        return null;
    }

    const count = numberFormat({ value: length });

    const labelClassName = classNames(classes.label, 'text-upper text-bold tbody-8');
    const attachmentsListWrapperClassName = classNames(classes.attachmentsListWrapper, className, 'b-l-0 b-r-0');

    return (
        <div className={attachmentsListWrapperClassName}>
            <div className={labelClassName} data-testid="attachments-count-label">
                <I18n k="send_message.attachments.attached_files" params={{ count }}/>
            </div>
            <div className={classes.attachmentsList} data-testid="attachments-list">
                {attachments.map(({ id }) => <Attachment className={classes.item} key={id} id={id}/>)}
            </div>
        </div>
    );
};

AttachmentsNotConnected.propTypes = {
    className: PropTypes.string,
    attachments: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired
        })
    ).isRequired
};

export const Attachments = ({ className }) => {
    const { attachments } = useAttachments();

    return <AttachmentsNotConnected attachments={attachments} className={className}/>;
};

Attachments.propTypes = {
    className: PropTypes.string
};
